import React, { FC } from 'react';
import configuratorControlsLayoutStyles from './configuratorControlsLayoutStyles';
import { Grid } from '@material-ui/core';

const ConfiguratorControlsLayout: FC = ({ children }) => {
  const styles = configuratorControlsLayoutStyles();

  return (
    <Grid
      data-test="common:configurator_controls_layout"
      item={true}
      xs={12}
      md={4}
      className={styles.controlsContainer}
    >
      {children}
    </Grid>
  );
};

export default ConfiguratorControlsLayout;
